import { render, staticRenderFns } from "./PropertyCell.vue?vue&type=template&id=68af58e6&scoped=true"
import script from "./PropertyCell.vue?vue&type=script&lang=js"
export * from "./PropertyCell.vue?vue&type=script&lang=js"
import style0 from "./PropertyCell.vue?vue&type=style&index=0&id=68af58e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68af58e6",
  null
  
)

export default component.exports